export const SESSION_RELOGIN_EVENT = "app:session-relogin";

/**
 * Opens the global session-relogin modal; resolves when the user clicks OK.
 * @param {string} message
 * @returns {Promise<void>}
 */
export function requestSessionReloginModal(message) {
  return new Promise((resolve) => {
    window.dispatchEvent(
      new CustomEvent(SESSION_RELOGIN_EVENT, {
        detail: { message, onAck: resolve },
      })
    );
  });
}
